export default "__VITE_ASSET__Ct_QjD0l__"